export default[
  {value: '0',text: '全部'},
  {value: '1', text: '基础音视频'},
  {value: '2', text: '物联网'},
  {value: '3', text: '视频AI'},
  {value: '4', text: '通话服务'},
  {value: '5', text: '语音AI'},
]